import { Injectable } from '@angular/core';
import moment from 'moment-timezone';
import { Weekdays } from './weekday-select.model';

@Injectable({
  providedIn: 'root',
})
export class WeekdaySelectService {
  static weekdayChoicesEnumValueToMoment(weekday: Weekdays): moment.Moment {
    return moment(weekday, 'E');
  }
}
